import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
	plugins: [createPersistedState()],
	state: {
		GateKeeperAnswers: []
	},
	mutations: {
		ADD_QUESTION(state, question) {
			state.GateKeeperAnswers.push(question)
		},
		RESET(state) {
			state.GateKeeperAnswers = []
		}
	},
	actions: {

	}
})
